import * as angular from 'angular';

import { TelemetryService } from '../Telemetry/mx-telemetry-service';
import { mxNavigationModule } from '../Navigation/navigation.module';

export const telemetryModule = angular
	.module('mx.sb.telemetry', [mxNavigationModule.name])
	.service('mx.sb.telemetry.service', TelemetryService)
	.run([
		'mx.sb.telemetry.service',
		function runModule(telemetryService: TelemetryService) {
			telemetryService.init();
		},
	]);
